var styles = ["app-report-task-detail[_ngcontent-%COMP%]{font-size:.7rem}"];
export { styles as styles };
